import { Typography, Grid, Card, CardContent, CardHeader, FormControlLabel } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { SCUIButton, SCUILoadingLinear } from '../../../../../atomic/atoms';
import '../../CreateReturn.scss';
import { ReturnCommand, PaymentCommand } from '../../../../../services/command';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import { PageUrl } from '../../../../../types/enums';
import creditcard from '../../../../../../src/assets/images/png/creditcard.png';
import cashondelivery from '../../../../../../src/assets/images/png/cashondelivery.png';
import { Paper, Box, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import lcwmoney from '../../../../../../src/assets/images/png/lcwmoney.png';
import { SCUIGeneralDrawer, SCUIGeneralDrawerHeader } from '../../../../../atomic/molecules';
import { DataQuery } from '../../../../../services/query';
import EditIcon from '@mui/icons-material/Edit';
import { ReturnCardAddDrawerContent } from '../ReturnCardAddDrawerContent/ReturnCardAddDrawerContent';
import { ReturnCardEditDrawerContent } from '../ReturnCardEditDrawerContent/ReturnCardEditDrawerContent';
import Helper from '../../../../../utils/helper';
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import { CRAS3 } from './createReturnActiveStep3.classes';
import { buildCreateReturnParams, buildInsertBankAccountParams } from '../../CreateReturnActiveStep3.helper';
import { ReturnQuery } from '../../../../../services/query';
import {
    extractCountryListFromPageRulesPayload,
    getReturnPageRulesCountryListCache,
    setReturnPageRulesCountryListCache,
} from '../returnPageRules.helper';

export const CreateReturnActiveStep3: FC<{
    selectedSellerID: any;
    isSellerStore: any;
    isCmMpRejectReturn: any;
    customerID: any;
    simulateReturn: any;
    createReturnRequest: any;
    selectedProductCount: any;
    showCMIY: boolean;
    isCheckedCMIY: boolean;
}> = ({
    selectedSellerID,
    isCmMpRejectReturn,
    isSellerStore,
    customerID,
    simulateReturn,
    createReturnRequest,
    selectedProductCount,
    showCMIY,
    isCheckedCMIY,
}) => {
    const checkedCMIY = isCheckedCMIY;
    const isCustomerRefundMethodChoiceRequired = simulateReturn.isCustomerRefundMethodChoiceRequired;

    let history = useHistory();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [returnId, setReturnId] = useState<any>();
    const [bankAccountList, setBankAccountList] = useState<any>();
    const [bankList, setBankList] = useState<any>();
    const [insertBankAccountRequest, setInsertBankAccountRequest] = useState<any>();
    const [drawerEditOpen, setDrawerEditOpen] = useState(false);
    const [drawerAddOpen, setDrawerAddOpen] = useState(false);
    const [isPaymentLcwMoney, setIsPaymentLcwMoney] = useState(Helper.isStoreEmployeeForFrontend() ? true : false); // mağaza kullnıcıları sdece lcwmoney seçebilecek
    const [isPaymentBankAccount, setIsPaymentBnkAccount] = useState(false);
    const [isPaymentCashOnStore, setIsPaymentCashOnStore] = useState(false);
    const [selectedBankAccount, setSelectedBnkAccount] = useState<any>();

    let storeCode = Helper.getStoreCode();
    const onDrawerAddOpen = () => {
        setInsertBankAccountRequest({
            bankSelection: null,
            nameSurname: '',
            accountNumber: '',
            swiftCode: '',
            iban: '',
            accountFatherName: '',
            nationalId: '',
        });
        setDrawerAddOpen(true);
        setDrawerEditOpen(false);
    };

    const onDrawerAddClose = () => setDrawerAddOpen(false);

    const onDrawerEditOpen = () => {
        if (selectedBankAccount) {
            setDrawerEditOpen(true);
            setDrawerAddOpen(false);
        } else {
            Swal.fire(t('customerInformation.selectAccountToEdit'), '', 'error');
        }
    };

    const onDrawerEditClose = () => setDrawerEditOpen(false);

    const createReturn = async () => {
        if (checkedCMIY) {
            Swal.fire({
                title: t('return.exceptionReturnSelected'),
                text: t('general.confirmContinue'),
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: t('general.no'),
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t('general.yesContinue'),
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await CallCreateReturn();
                }
            });
        } else {
            await CallCreateReturn();
        }
        async function CallCreateReturn() {
            if (!selectedSellerID && isCmMpRejectReturn) {
                Swal.fire(t('general.pleaseSelectCompanyFromPreviousTab'), ' ', 'error');
                return;
            }

            setLoading(true);
            setDisabled(true);

            const params = buildCreateReturnParams({
                createReturnRequest,
                isSellerStore,
                checkedCMIY,
                simulateReturn,
                selectedSellerID,
                isCmMpRejectReturn,
                isCustomerRefundMethodChoiceRequired,
                isPaymentBankAccount,
                selectedBankAccount,
                isPaymentCashOnStore,
                isPaymentLcwMoney,
            });

            createReturnRequest.expectedRefundTotal = simulateReturn.returnAmount;
            try {
                let res = await ReturnCommand.CreateReturn(params);
                if (res.returnedProductProcess) {
                    Swal.fire({
                        icon: 'error',
                        title: res.returnedProductProcess?.returnMessages,
                    });
                }
                if (res.model.returnId === 0 && storeCode) {
                    Swal.fire({
                        icon: 'error',
                        title: res.model.returnTransactionSummaryText,
                    });
                    return;
                }
                if (res && res.model) {
                    setReturnId(res.model.returnId);
                    setLoading(false);
                    history.push(
                        PageUrl.returnDetail.url + '?ReturnId=' + res.model.returnId + '&customerId=' + customerID
                    );
                }
                if (res && res.error) {
                    Swal.fire({
                        icon: 'error',
                        title: res.error,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            } finally {
                setLoading(false);
            }
        }
    };

    const DeleteBankAccount = async () => {
        if (selectedBankAccount) {
            Swal.fire({
                text: t('general.deleteConfirmationText'),
                cancelButtonText: t('general.cancel'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t('general.delete'),
            }).then((result: any) => {
                if (result.isConfirmed) {
                    let params: any = {};
                    params.bankAccount = selectedBankAccount;
                    params.customerId = customerID;
                    params.bankAccount.status = false;
                    PaymentCommand.DeleteCustomerBankAccount(params)
                        .then((res: any) => {
                            if (res && res.result) {
                                GetAcountListByCustomerId();
                            } else {
                                Swal.fire(' ', ' ', 'error');
                            }
                        })
                        .catch((error: any) => {
                            switch (error.status) {
                                case 401:
                                    Swal.fire(t('general.sessionExpiredError'), '', 'error');
                                    break;
                                case 403:
                                    Swal.fire(t('general.authorizationError'), '', 'error');
                                    break;
                                case 404:
                                    Swal.fire(t('general.notFoundError'), '', 'error');
                                    break;
                                case 500:
                                    Swal.fire(t('general.serviceError'), '', 'error');
                                    break;
                                case 400:
                                    Swal.fire({
                                        icon: 'error',
                                        title: error.data,
                                        showConfirmButton: false,
                                        timer: 1500,
                                    });
                            }
                        });
                }
            });
        } else Swal.fire(t('customerInformation.deleteSelectAccount'), ' ', 'error');
    };

    useEffect(() => {
        if (customerID && isCustomerRefundMethodChoiceRequired) {
            GetAcountListByCustomerId();
        }
        setInsertBankAccountRequest({ ...insertBankAccountRequest });
    }, [customerID]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (isCustomerRefundMethodChoiceRequired) {
            GetBankList();
        }
    }, []);

    // İlk görünen selectable kartı otomatik seç
    useEffect(() => {
        if (simulateReturn?.refundPlanList && isCustomerRefundMethodChoiceRequired) {
            // Tüm payment state'lerini sıfırla
            setIsPaymentBnkAccount(false);
            setIsPaymentLcwMoney(false);
            setIsPaymentCashOnStore(false);
            setSelectedBnkAccount(null);

            // İlk görünen selectable kartı bul ve seç (sırayla kontrol et)
            // 1. Cash Refund (20)
            if (simulateReturn.refundPlanList.some((plan: any) => plan.refundPlanMethod === 20 && plan.isSelectable)) {
                setIsPaymentCashOnStore(true);
            }
            // 2. LCW Money (3)
            else if (
                simulateReturn.refundPlanList.some((plan: any) => plan.refundPlanMethod === 3 && plan.isSelectable)
            ) {
                setIsPaymentLcwMoney(true);
            }
            // 3. Bank Transfer (1)
            else if (
                simulateReturn.refundPlanList.some((plan: any) => plan.refundPlanMethod === 1 && plan.isSelectable)
            ) {
                setIsPaymentBnkAccount(true);
            }
        }
    }, [simulateReturn?.refundPlanList, isCustomerRefundMethodChoiceRequired]);

    const prefetchReturnPageRulesCountryList = async () => {
        if (getReturnPageRulesCountryListCache()) return;

        try {
            const response = await ReturnQuery.GetPageRulesList({ CountryId: Helper.GetCurrentCountry() });
            const payload = response?.data || response;
            setReturnPageRulesCountryListCache(extractCountryListFromPageRulesPayload(payload));
        } catch (error) {
            console.error('Error prefetching return page rules country list:', error);
        }
    };

    const GetAcountListByCustomerId = async () => {
        prefetchReturnPageRulesCountryList();
        PaymentCommand.GetBankAccountListByCustomer({
            customerID: customerID,
        }).then((res: any) => {
            if (res) setBankAccountList(res.bankAccountList);
        });
    };

    const GetBankList = async () => {
        DataQuery.GetBankList().then((res: any) => {
            if (res) setBankList(res.data.bankList);
        });
    };

    const InsertBankAccount = async () => {
        const params = buildInsertBankAccountParams(insertBankAccountRequest, customerID);

        try {
            const res = await PaymentCommand.InsertCustomerBankAccount(params);
            if (res) {
                GetAcountListByCustomerId();
                Swal.fire('', ' ', 'success');
            }
        } catch (error: any) {
            switch (error.status) {
                case 401:
                    Swal.fire(t('general.sessionExpiredError'), '', 'error');
                    break;
                case 403:
                    Swal.fire(t('general.authorizationError'), '', 'error');
                    break;
                case 404:
                    Swal.fire(t('general.notFoundError'), '', 'error');
                    break;
                case 500:
                    Swal.fire(t('general.serviceError'), '', 'error');
                    break;
                case 400:
                    Swal.fire({
                        icon: 'error',
                        title: error.data,
                        showConfirmButton: false,
                        timer: 1500,
                    });
            }
        }
    };
    const handleBankAccountUpdate = (success: boolean, formData: any) => {
        if (success) {
            const params = {
                bankAccount: {
                    bankId: formData.bankSelection,
                    accountOwner: formData.nameSurname || formData.accountHolder,
                    accountNumber: formData.accountNumber,
                    bankCode: formData.swiftCode,
                    ibanNumber: formData.iban ? formData.iban.replace(/\s/g, '') : '',
                    bankAccountId: selectedBankAccount.bankAccountId,
                    status: true,
                    street: formData.street || '',
                    house: formData.house || '',
                    postalCode: formData.postalCode || '',
                    nationalId: formData.nationalId || '',
                    personalNumber: formData.personalNumber || '',
                    accountFatherName: formData.accountFatherName,
                },
                customerId: customerID,
            };

            PaymentCommand.UpdateCustomerBankAccount(params)
                .then((res: any) => {
                    if (res && res.result) {
                        GetAcountListByCustomerId();
                        onDrawerEditClose();
                        Swal.fire('', ' ', 'success');
                    } else {
                        Swal.fire(' ', ' ', 'error');
                    }
                })
                .catch((error: any) => {
                    switch (error.status) {
                        case 401:
                            Swal.fire(t('general.sessionExpiredError'), '', 'error');
                            break;
                        case 403:
                            Swal.fire(t('general.authorizationError'), '', 'error');
                            break;
                        case 404:
                            Swal.fire(t('general.notFoundError'), '', 'error');
                            break;
                        case 500:
                            Swal.fire(t('general.serviceError'), '', 'error');
                            break;
                        case 400:
                            Swal.fire({
                                icon: 'error',
                                title: error.data,
                                showConfirmButton: false,
                                timer: 1500,
                            });
                    }
                });
        }
    };
    return (
        <Grid className={CRAS3.root} container sx={{ marginTop: '0.1rem' }}>
            <div className={CRAS3.loadingSection}>
                <SCUILoadingLinear display={loading} />
            </div>
            <SCUIGeneralDrawer
                open={drawerAddOpen}
                onClose={(_: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        onDrawerAddClose();
                    }
                }}
                width={'400px'}
                paperClassName={CRAS3.addDrawerPaper}
            >
                <SCUIGeneralDrawerHeader
                    header={t('general.newBankInfo')}
                    onClose={onDrawerAddClose}
                    rootClassName={CRAS3.addDrawerHeaderRoot}
                    titleClassName={CRAS3.addDrawerHeaderTitle}
                    closeIconClassName={CRAS3.addDrawerHeaderCloseIcon}
                />
                <Box sx={{ width: '100%' }} className={CRAS3.addDrawerContent}>
                    <ReturnCardAddDrawerContent
                        bankList={bankList}
                        setInsertBankAccountRequest={setInsertBankAccountRequest}
                        insertBankAccountRequest={insertBankAccountRequest}
                        InsertBankAccount={InsertBankAccount}
                        onClose={onDrawerAddClose}
                    />
                </Box>
            </SCUIGeneralDrawer>
            <SCUIGeneralDrawer
                open={drawerEditOpen}
                onClose={(_: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        onDrawerEditClose();
                    }
                }}
                width={'400px'}
                paperClassName={CRAS3.editDrawerPaper}
            >
                <div className={CRAS3.editDrawerContent}>
                    <ReturnCardEditDrawerContent
                        bankList={bankList}
                        selectedBankAccount={selectedBankAccount}
                        onClose={onDrawerEditClose}
                        onUpdateBankAccount={handleBankAccountUpdate}
                    />
                </div>
            </SCUIGeneralDrawer>
            <Grid
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <p>
                    <b className={CRAS3.sectionTitle}>{t('return.refundPaymentInformation')}</b>
                </p>
            </Grid>
            <Grid
                size={{
                    xl: 4,
                    lg: 3,
                    md: 12,
                    xs: 12,
                }}
            >
                <p>
                    <b>{t('return.totalRefundAmount')} : </b>
                    <span className={CRAS3.refundAmountText}>
                        {Helper.formatNumber(simulateReturn.returnAmount)} {simulateReturn.currencySymbol}
                    </span>
                </p>
            </Grid>
            <Grid
                size={{
                    xl: 4,
                    lg: 3,
                    md: 12,
                    xs: 12,
                }}
            >
                <p>
                    <b>{t('general.totalProductQuantity')} : </b>
                    <span className={CRAS3.productCountText}>{selectedProductCount}</span>
                </p>
            </Grid>
            <Grid
                size={{
                    xl: 4,
                    lg: 3,
                    md: 12,
                    xs: 12,
                }}
            >
                {(!isCustomerRefundMethodChoiceRequired ||
                    isPaymentLcwMoney ||
                    selectedBankAccount ||
                    isPaymentCashOnStore) && (
                    <SCUIButton
                        className={CRAS3.approveButton}
                        text={t('return.approveReturnRequest')}
                        type="secondary"
                        sizeType="fixed"
                        size={'m'}
                        onClick={createReturn}
                        disabled={disabled}
                    />
                )}
            </Grid>
            {simulateReturn.refundPlanList.payments &&
                simulateReturn.refundPlanList.map((payment: any, index: number) => (
                    <Grid
                        key={index}
                        size={{
                            xl: 3,
                            lg: 4,
                            sm: 12,
                            xs: 12,
                        }}
                    >
                        <Card style={{ height: '14rem', width: '36rem' }}>
                            <CardContent>
                                {payment.paymentMethodId === 7 && <img src={cashondelivery} height="32px" alt=""></img>}
                                {payment.paymentMethodId === 3 && <img src={lcwmoney} height="32px" alt=""></img>}
                                {payment.paymentMethodId === 2 && <img src={creditcard} height="32px" alt=""></img>}
                                <Typography variant="caption" display="block" gutterBottom>
                                    {payment.paymentMethodKey}
                                </Typography>
                                <Typography variant="caption" display="block" gutterBottom>
                                    {payment.confirmedAmount}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            <Grid
                size={{
                    xl: 12,
                    lg: 12,
                    sm: 12,
                    xs: 12,
                }}
            >
                {showCMIY && (
                    <FormControlLabel
                        className={CRAS3.cmiYControl}
                        style={{ color: checkedCMIY ? 'red' : '' }}
                        control={
                            <Checkbox
                                className={CRAS3.cmiYCheckbox}
                                disabled
                                checked={checkedCMIY}
                                name="checkedB"
                                color="primary"
                                style={{ color: checkedCMIY ? 'red' : '' }}
                            />
                        }
                        label={t('return.exceptionReturn')}
                    />
                )}
            </Grid>
            <Grid
                alignItems="center"
                sx={{ padding: 2, marginTop: 5 }}
                size={{
                    xl: 12,
                    lg: 12,
                    sm: 12,
                    xs: 12,
                }}
            >
                <p>
                    <b className={CRAS3.planInfoHeader}>{t('return.refundWillBeProcessedAsFollows')}</b>
                </p>
            </Grid>
            <Grid
                size={{
                    xl: 12,
                    lg: 12,
                    sm: 12,
                    xs: 12,
                }}
            >
                <Box height="100%" width="100%" display="flex" justifyContent="center" flexDirection="column">
                    <TableContainer className={CRAS3.planTableWrap} component={Paper} sx={{ marginTop: 2 }}>
                        <Table className={CRAS3.planTable} aria-label="simple table">
                            <TableBody>
                                {simulateReturn.refundPlanList.map((refundPlan: any, index: number) => {
                                    const isSelectable = refundPlan.isSelectable;
                                    if (isSelectable) {
                                        const isFirstSelectable =
                                            simulateReturn.refundPlanList.findIndex(
                                                (plan: any) => plan.isSelectable
                                            ) === index;

                                        if (isFirstSelectable) {
                                            const selectableMethods = simulateReturn.refundPlanList
                                                .filter((plan: any) => plan.isSelectable)
                                                .map((plan: any) => plan.refundPlanMethodDescription)
                                                .join(' - ');

                                            return (
                                                <TableRow className={CRAS3.planRow} key={index}>
                                                    <TableCell
                                                        className={CRAS3.planCellMethod}
                                                        component="th"
                                                        scope="row"
                                                    >
                                                        {selectableMethods}
                                                    </TableCell>
                                                    <TableCell className={CRAS3.planCellAmount}>
                                                        {Helper.formatNumber(refundPlan.amount)}{' '}
                                                        {simulateReturn.currencySymbol}
                                                    </TableCell>
                                                    <TableCell className={CRAS3.planCellStatus}>
                                                        {Helper.getRefundStatusName(refundPlan.refundPlanStatus)}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        } else {
                                            return null;
                                        }
                                    } else {
                                        return (
                                            <TableRow className={CRAS3.planRow} key={index}>
                                                <TableCell className={CRAS3.planCellMethod} component="th" scope="row">
                                                    {refundPlan.refundPlanMethodDescription}
                                                </TableCell>
                                                <TableCell className={CRAS3.planCellAmount}>
                                                    {Helper.formatNumber(refundPlan.amount)}{' '}
                                                    {simulateReturn.currencySymbol}
                                                </TableCell>
                                                <TableCell className={CRAS3.planCellStatus}>
                                                    {Helper.getRefundStatusName(refundPlan.refundPlanStatus)}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Grid>
            {isCustomerRefundMethodChoiceRequired && (
                <>
                    {simulateReturn.refundPlanList?.some((plan: any) => plan.isSelectable) && (
                        <Grid
                            sx={{ padding: 2, marginTop: 2 }}
                            size={{
                                xl: 12,
                                lg: 12,
                                sm: 12,
                                xs: 12,
                            }}
                        >
                            <p>
                                <b className={CRAS3.selectMethodHeader}>{t('return.pleaseSelectRefundMethod')}</b>
                            </p>
                        </Grid>
                    )}{' '}
                    {simulateReturn.refundPlanList?.some(
                        (plan: any) => plan.refundPlanMethod === 20 && plan.isSelectable
                    ) && (
                        <Grid
                            size={{
                                xl: 3,
                                lg: 4,
                                sm: 12,
                                xs: 12,
                            }}
                        >
                            <Card
                                className={[
                                    CRAS3.methodCardCash,
                                    isPaymentCashOnStore ? 'selectedCardForReturnPayment' : '',
                                ]
                                    .filter(Boolean)
                                    .join(' ')}
                                style={{ height: '14rem' }}
                                onClick={() => {
                                    setIsPaymentBnkAccount(false);
                                    setIsPaymentLcwMoney(false);
                                    setIsPaymentCashOnStore(true);
                                    setSelectedBnkAccount(null);
                                }}
                            >
                                <CardContent>
                                    <PointOfSaleIcon
                                        fontSize="inherit"
                                        style={{ color: '#1976d2', marginRight: 8, fontSize: 38 }}
                                    />
                                    <LocalAtmIcon fontSize="inherit" style={{ color: '#43a047', fontSize: 38 }} />
                                    <Typography variant="caption" display="block" gutterBottom>
                                        {t('general.cashRefund')}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    )}
                    {simulateReturn.refundPlanList?.some(
                        (plan: any) => plan.refundPlanMethod === 3 && plan.isSelectable
                    ) && (
                        <Grid
                            size={{
                                xl: 3,
                                lg: 4,
                                sm: 12,
                                xs: 12,
                            }}
                        >
                            <Card
                                className={[
                                    CRAS3.methodCardLcwMoney,
                                    isPaymentLcwMoney ? 'selectedCardForReturnPayment' : '',
                                ]
                                    .filter(Boolean)
                                    .join(' ')}
                                style={{ height: '14rem' }}
                                onClick={() => {
                                    setIsPaymentBnkAccount(false);
                                    setIsPaymentCashOnStore(false);
                                    setIsPaymentLcwMoney(true);
                                    setSelectedBnkAccount(null);
                                }}
                            >
                                <CardContent>
                                    <img src={lcwmoney} height="32px" alt="" />
                                    <Typography variant="caption" display="block" gutterBottom>
                                        {t('customerInformation.lcwMoney')}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    )}
                    {simulateReturn.refundPlanList?.some(
                        (plan: any) => plan.refundPlanMethod === 1 && plan.isSelectable
                    ) && (
                        <Grid
                            size={{
                                xl: 3,
                                lg: 4,
                                sm: 12,
                                xs: 12,
                            }}
                        >
                            <Card
                                className={[
                                    CRAS3.methodCardBank,
                                    isPaymentBankAccount ? 'selectedCardForReturnPayment' : '',
                                ]
                                    .filter(Boolean)
                                    .join(' ')}
                                style={{ height: '14rem' }}
                                onClick={() => {
                                    setIsPaymentBnkAccount(true);
                                    setIsPaymentLcwMoney(false);
                                    setIsPaymentCashOnStore(false);
                                }}
                            >
                                <CardContent>
                                    <img src={creditcard} height="32px" alt="" />
                                    <Typography variant="caption" display="block" gutterBottom>
                                        {t('general.bankTransfer')}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    )}
                    <Grid
                        size={{
                            xl: 6,
                            lg: 4,
                            sm: 12,
                            xs: 12,
                        }}
                    ></Grid>
                </>
            )}
            {isPaymentBankAccount && (
                <>
                    <Grid
                        sx={{ padding: 2, marginTop: 2 }}
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            sm: 12,
                            xs: 12,
                        }}
                    >
                        <b className={CRAS3.savedBankInfoTitle}>{t('general.savedBankInfo')}</b>
                    </Grid>
                    <Grid
                        sx={{ padding: 2, marginTop: 2 }}
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            sm: 12,
                            xs: 12,
                        }}
                    >
                        <b
                            className={[CRAS3.addNewBankInfoLink, 'linktxt'].join(' ')}
                            onClick={() => onDrawerAddOpen()}
                        >
                            + {t('general.addNewBankInfo')}
                        </b>
                    </Grid>

                    {bankAccountList &&
                        bankAccountList.map((bankAccount: any) => (
                            <Grid
                                key={bankAccount.bankAccountId}
                                size={{
                                    xl: 3,
                                    lg: 4,
                                    sm: 12,
                                    xs: 12,
                                }}
                            >
                                <Card
                                    className={[
                                        CRAS3.bankAccountCard,
                                        selectedBankAccount &&
                                        selectedBankAccount.bankAccountId === bankAccount.bankAccountId
                                            ? 'selectedCardForReturnPayment'
                                            : '',
                                    ]
                                        .filter(Boolean)
                                        .join(' ')}
                                    onClick={() => {
                                        setSelectedBnkAccount(bankAccount);
                                    }}
                                >
                                    <CardHeader
                                        title={
                                            <Typography noWrap gutterBottom variant="h6" component="h4">
                                                <b className={CRAS3.bankAccountCardTitle}>
                                                    {bankAccount.bankName} {bankAccount.bankCode}
                                                </b>
                                            </Typography>
                                        }
                                    />
                                    <CardContent>
                                        <br />
                                        <p>{bankAccount.ibanNumber}</p>
                                        <p>{bankAccount.accountOwner}</p>
                                        <p>{bankAccount.accountNumber}</p>
                                        <label
                                            className={CRAS3.bankAccountEditLink}
                                            style={{
                                                color: 'green',
                                                cursor: 'pointer',
                                                paddingRight: 30,
                                            }}
                                            onClick={() => onDrawerEditOpen()}
                                        >
                                            <EditIcon color="success" /> {t('general.edit')}
                                        </label>
                                        <label
                                            className={CRAS3.bankAccountDeleteLink}
                                            style={{ color: 'red', cursor: 'pointer' }}
                                            onClick={() => DeleteBankAccount()}
                                        >
                                            <DeleteIcon color="error" /> {t('general.delete')}
                                        </label>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                </>
            )}
            <br />
            <Grid
                sx={{ padding: 3 }}
                size={{
                    xl: 12,
                    lg: 6,
                    md: 6,
                    sm: 12,
                    xs: 12,
                }}
            ></Grid>
            {Helper.isStoreEmployeeForFrontend() && (
                <>
                    {disabled && (
                        <Grid
                            size={{
                                xl: 6,
                                lg: 6,
                                md: 6,
                                sm: 12,
                                xs: 12,
                            }}
                        >
                            <Card
                                className={CRAS3.storeEmployeeWarningCard}
                                style={{
                                    textAlign: 'center',
                                    height: '20rem',
                                    margin: 5,
                                    padding: 5,
                                }}
                            >
                                <CardHeader />
                                <CardContent style={{ textAlign: 'center' }}>
                                    <Typography
                                        variant="h3"
                                        display="block"
                                        gutterBottom
                                        color="red"
                                        sx={{ padding: 1 }}
                                    >
                                        <b>{t('return.refundNotCompleted')}</b>{' '}
                                    </Typography>
                                    <Typography
                                        variant="h3"
                                        display="block"
                                        gutterBottom
                                        color="red"
                                        sx={{ padding: 1 }}
                                    >
                                        <b>{t('return.completeRefundRecord')}</b>
                                    </Typography>
                                    <p> </p>
                                    {returnId && returnId !== 0 && (
                                        <SCUIButton
                                            className={CRAS3.goToReturnDetailButton}
                                            text={t('return.goToReturnDetail')}
                                            type="secondary"
                                            sizeType="fixed"
                                            size={'m'}
                                            onClick={() =>
                                                history.push(
                                                    PageUrl.returnDetail.url +
                                                        '?ReturnId=' +
                                                        returnId +
                                                        '&customerId=' +
                                                        customerID
                                                )
                                            }
                                        />
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    )}
                    <Grid
                        size={{
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 12,
                            xs: 12,
                        }}
                    >
                        <Card
                            className={CRAS3.returnAddressCard}
                            style={{
                                textAlign: 'center',
                                height: '20rem',
                                margin: 5,
                                padding: 5,
                            }}
                        >
                            <CardHeader
                                title={
                                    <Typography noWrap gutterBottom variant="h6" component="h4">
                                        {t('return.returnAddress')}
                                    </Typography>
                                }
                            />
                            <CardContent style={{ textAlign: 'center' }}>
                                <p>Lc Waikiki Mağazacılık Hiz. Tic. A. Ş. Lojistik Merkezi / İade Bölümü</p>
                                <p>Sanayi Mh. 1642. Sk. No:1 34517 Esenyurt - İstanbul</p>
                                <p>Tel: 444 4 LCW (444 4 529)</p>
                            </CardContent>
                        </Card>
                    </Grid>
                </>
            )}
        </Grid>
    );
};
